import styled from 'styled-components';

// Constants
import { button } from 'constants/style';
import breakpoints from 'constants/breakpoints';

export const CloseOnTouch = styled.div`
  background-color: transparent;
  cursor: pointer;
  height: ${button.large}px;
`;

export const Container = styled.div`
  height: 100%;
  left: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  position: fixed;
  top: 0;
  transform: translateY(100vh);
  transition: transform 0.5s cubic-bezier(0, 0, 0, 1);
  width: 100%;
  z-index: 102;
  &.open {
    transform: translateY(0);
  }
`;

export const Modal = styled.div`
  background-color: var(--color-neutral__card-background);
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  box-shadow: 0px -5px 12px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  // Subtract 'CloseOnTouch' height to prevent unnecessary scrolling.
  min-height: calc(100% - ${button.large}px);
  height: fit-content;
  @media (min-width: ${breakpoints.md}px) {
    display: block;
  }
`;

export const Underlay = styled.div`
  // Use 'linear-gradient' to prevent the main page from bleeding through
  // when certain browsers bounce the modal when it is no longer scrollable.
  background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0.5) 100%);
  bottom: 0;
  height: 100%;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  transition: opacity 0.5s cubic-bezier(0, 0, 0, 1);
  width: 100%;
  z-index: 101;

  &.open {
    opacity: 1;
    // Use a cubic-bezier with a shallow ascent when opening the modal
    // (so the shadow effect grows more intense at the end of the animation),
    // and use a cubic-bezier with a sharp descent when closing the modal
    // (so the shadow effect quickly fades out at the start of the animation).
    transition: opacity 0.5s cubic-bezier(0, 0, 1, 0);
  }
`;
